
const EmailIcon = () => {
    return (
        <svg style={{opacity: "1"}} className={"svg-icon"} width="25" height="24" viewBox="0 0 25 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12.5002 15.7495C14.5713 15.7495 16.2502 14.0706 16.2502 11.9995C16.2502 9.92844 14.5713 8.24951 12.5002 8.24951C10.4292 8.24951 8.75024 9.92844 8.75024 11.9995C8.75024 14.0706 10.4292 15.7495 12.5002 15.7495Z"
                stroke="#7B7E7C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path
                d="M17.4767 19.4997C15.8058 20.6086 13.8125 21.1278 11.813 20.9748C9.81346 20.8218 7.92229 20.0055 6.43954 18.6553C4.9568 17.3052 3.96741 15.4985 3.62837 13.522C3.28932 11.5455 3.62004 9.51242 4.56805 7.74529C5.51606 5.97816 7.02705 4.57822 8.86128 3.76762C10.6955 2.95702 12.7479 2.78217 14.6928 3.27083C16.6377 3.75949 18.3638 4.88366 19.597 6.46497C20.8303 8.04628 21.5001 9.99416 21.5003 11.9995C21.5003 14.0706 20.7503 15.7495 18.8753 15.7495C17.0003 15.7495 16.2503 14.0706 16.2503 11.9995V8.24952"
                stroke="#7B7E7C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default EmailIcon